var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 12.6667V14.6667H1.33301V12.6667C1.33301 12.3 1.63301 12 1.99967 12H13.9997C14.3663 12 14.6663 12.3 14.6663 12.6667Z",
    fill: "#AEBFD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.33366 7.33325H2.66699V11.9999H5.33366V7.33325Z",
    fill: "#AEBFD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.99967 7.33325H5.33301V11.9999H7.99967V7.33325Z",
    fill: "#AEBFD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.6667 7.33325H8V11.9999H10.6667V7.33325Z",
    fill: "#AEBFD3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3337 7.33325H10.667V11.9999H13.3337V7.33325Z",
    fill: "#AEBFD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 15.1667H0.666992C0.393659 15.1667 0.166992 14.9401 0.166992 14.6667C0.166992 14.3934 0.393659 14.1667 0.666992 14.1667H15.3337C15.607 14.1667 15.8337 14.3934 15.8337 14.6667C15.8337 14.9401 15.607 15.1667 15.3337 15.1667Z",
    fill: "#AEBFD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2463 3.83329L8.24634 1.43331C8.113 1.37998 7.88634 1.37998 7.75301 1.43331L1.75301 3.83329C1.51968 3.92663 1.33301 4.19996 1.33301 4.45329V6.66663C1.33301 7.03329 1.63301 7.33329 1.99967 7.33329H13.9997C14.3663 7.33329 14.6663 7.03329 14.6663 6.66663V4.45329C14.6663 4.19996 14.4797 3.92663 14.2463 3.83329ZM7.99967 5.66663C7.44634 5.66663 6.99967 5.21996 6.99967 4.66663C6.99967 4.11329 7.44634 3.66663 7.99967 3.66663C8.55301 3.66663 8.99967 4.11329 8.99967 4.66663C8.99967 5.21996 8.55301 5.66663 7.99967 5.66663Z",
    fill: "#AEBFD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.eec47058.svg";
export { ForwardRef as ReactComponent };